import type { RowerProfile } from '../services/users/rowerService';

/** Canonical identity fields on `profiles` (auth-linked root user row). */
export type RootProfileIdentity = {
  first_name?: string | null;
  last_name?: string | null;
  date_of_birth?: string | null;
};

function nonEmpty(value: string | null | undefined): string | null {
  if (value == null) return null;
  const t = value.trim();
  return t ? t : null;
}

/**
 * Fill rower_profiles gaps from profiles without overwriting athlete-edited values.
 */
export function mergeRowerProfileWithRootProfile<T extends RowerProfile>(
  rower: T,
  root: RootProfileIdentity | null | undefined
): T {
  if (!root) return rower;

  const first_name = nonEmpty(rower.first_name) ?? nonEmpty(root.first_name) ?? rower.first_name;
  const last_name = nonEmpty(rower.last_name) ?? nonEmpty(root.last_name) ?? rower.last_name;
  const date_of_birth = rower.date_of_birth ?? root.date_of_birth ?? null;

  if (
    first_name === rower.first_name &&
    last_name === rower.last_name &&
    date_of_birth === rower.date_of_birth
  ) {
    return rower;
  }

  return {
    ...rower,
    first_name,
    last_name,
    date_of_birth,
  };
}
